<template>
  <div class="page">
    <div class="tab-box">
      <div v-if="$hasRole('clerk')" class="tab-item" :class="tab == 'clerk' ? 'item-click' : ''" @click="tabClick('clerk')">
        <span>店员</span>
        <div v-if="tab == 'clerk'" class="l"></div>
      </div>
      <div v-if="$hasRole('leader')" class="tab-item" :class="tab == 'leader' ? 'item-click' : ''" @click="tabClick('leader')">
        <span>组长</span>
        <div v-if="tab == 'leader'" class="l"></div>
      </div>
      <div v-if="$hasRole('kf')" class="tab-item" :class="tab == 'kf' ? 'item-click' : ''" @click="tabClick('kf')">
        <span>客服</span>
        <div v-if="tab == 'kf'" class="l"></div>
      </div>
      <div v-if="$hasRole('admin')" class="tab-item" :class="tab == 'admin' ? 'item-click' : ''" @click="tabClick('admin')">
        <span>管理员</span>
        <div v-if="tab == 'admin'" class="l"></div>
      </div>
      <div v-if="accountBalance" class="tab-item" :class="tab == 'account' ? 'item-click' : ''" @click="tabClick('account')">
        <span>其他角色</span>
        <div v-if="tab == 'account'" class="l"></div>
      </div>
    </div>
    <div class="wallet-box">
      <div class="wallet">
        <div class="line1">
          <div class="left-box">
            <div class="title">
              <div>总余额</div>
              <div class="unit">(元)</div>
            </div>
            <div class="amount">{{ balance ? formatPrice(balance) : 0 }}</div>
          </div>
          <div class="right-box">
            <div class="button button-margin" v-if=" (tab!=='clerk' && showTX) || clerkSetting.wageSettleType === 'flexible'" @click="txpop = true">提现</div>
            <div v-if="tab == 'clerk' && showCZ" @click="czpop = true" class="button">充值</div>
          </div>
        </div>
        <div v-show="tab==='clerk' || accountSetting.accountBalanceEnable" class="line2">
          <div><span>{{clerkSetting.wageSettleType === 'flexible' || tab!=='clerk' ?'可提现':'待结算'}}</span>：{{formatPrice(okWithdrawal)}}</div>
          <div v-if="tab == 'clerk'">冻结：{{formatPrice(frozeAmount)}}</div>
        </div>
        <img class="wallet-bg" src="/static/images/default/wallet.png">
      </div>
    </div>
    <div class="list-title">
      <div>收支明细</div>
      <div class="time" @click="timeClick">
        <span>{{startTime && endTime ? startTime + ' 至 ' + endTime : '日期选择'}}</span>
        <img src="/static/images/default/select.png">
      </div>
    </div>
    <div class="list-box">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="listBalanceDetail">
        <div class="list-item" v-for="(item, index) in detailList" :key="index" @click="onLogClick(item)">
          <div>
            <div class="flex align-center">
              <div class="text1">{{ item.actionName }}</div>
              <div v-if="item.action === 'withdraw'">
                <van-tag v-if="item.status === 0" type="warning">待付款</van-tag>
                <van-tag v-if="item.status === 1" type="primary">付款中</van-tag>
                <van-tag v-if="item.status === 2" type="success">已付款</van-tag>
                <van-tag v-if="item.status === 3" type="danger">付款失败</van-tag>
                <van-tag v-if="item.status === -1">已撤销</van-tag>
              </div>
            </div>
<!--            <div class="text2">xxxx-xx-xx xx:xx</div>-->
            <div class="text2" v-if="item.detail && item.detail.platformFee">
              手续费（{{item.detail.platformFeeRatio}}）：{{ formatPrice(item.detail.platformFee) }}
            </div>
            <div class="text2" v-if="item.action == 'update'">
              备注：{{ item.detail.remark }}
            </div>
            <div class="text2">{{ formatDate(item.createTime, 'YYYY-MM-DD HH:mm') }}</div>
          </div>
          <div>
            <div class="text3">{{ item.changeAmount > 0 ? '+' : '' }}{{ formatPrice(item.changeAmount) }}</div>
            <div class="text4">账号余额：{{ formatPrice(item.afterChangeAmount) }}</div>
          </div>
        </div>
      </van-list>

    </div>

    <van-popup class="popstyle" v-model="timePop" :close-on-click-overlay="false" position="bottom">
      <van-cell title="开始时间" :value="startTime" is-link @click="showDatetimePickerPopup('start')"/>
      <van-cell title="结束时间" :value="endTime" is-link @click="showDatetimePickerPopup('end')"/>
      <div class="button-box">
        <div class="button1" @click="cancellation">{{startTime && endTime ? '重置' : '取消'}}</div>
        <div class="button2" @click="queryClick">查询</div>
      </div>
    </van-popup>
    <van-popup v-model="datetimePickerPopupShow" position="bottom">
      <van-datetime-picker
          v-model="datetimePicker.value"
          type="date"
          :max-date="datetimePicker.maxDate"
          :formatter="datetimePickerFormatter"
          @confirm="datetimePickerConfirm"
          @cancel="datetimePickerPopupShow = false"
      />
    </van-popup>

    <van-popup class="txpop" v-model="txpop" :close-on-click-overlay="false">
      <div class="title">
        <span>提现</span>
        <img @click="txpop = false" src="/static/images/default/x2.png">
      </div>
      <div class="popbody">
        <div class="line">
          <div class="line-title">提现金额</div>
          <van-field class="field" v-model="withdrawalAmount" placeholder="请输入提现金额" type="number"/>
        </div>
        <div class="tip">最大可提现余额：{{ okWithdrawal ? formatPrice(okWithdrawal) : 0 }}</div>
        <div class="line">
          <div class="line-title">微信实名</div>
          <van-field class="field" v-model="realName" placeholder="账号绑定的微信号实名名字"/>
        </div>
        <div class="tip2">注意：请用绑定微信的实名名字，不然会导致付款失败!</div>
        <van-uploader
            v-if="accountSetting.uploadScreenshotEnable"
            v-model="imgList"
            :max-count="3"
            accept="image/*"
            class="image-uploader"
            multiple
            preview-size="70"
            style="margin-top: 15px"
            upload-icon="plus"/>
        <div class="bottom-button" @click="withdrawClick">提现</div>
      </div>
    </van-popup>

    <van-popup class="txpop" v-model="czpop" :close-on-click-overlay="false">
      <div class="title">
        <span>充值</span>
        <img @click="czpop = false" src="/static/images/default/x2.png">
      </div>
      <div class="popbody">
        <div class="line">
          <div class="line-title">充值金额</div>
          <van-field class="field" v-model="recharge" placeholder="请输入充值金额" type="number"/>
        </div>
        <div class="pay-box">
          <div v-if="rechargePayMethodList.indexOf('weixin') != -1" class="pay-item">
            <div class="left-box">
              <img src="/static/images/default/wx.png">
              <span>微信支付</span>
            </div>
            <div @click="pay = 'weixin'" :class="pay == 'weixin' ? 'ok' : 'no'">
              <img v-if="pay == 'weixin'" src="/static/images/default/y.png">
            </div>
          </div>
          <div v-if="rechargePayMethodList.indexOf('alipay') != -1" class="pay-item">
            <div class="left-box">
              <img src="/static/images/default/zfb.png">
              <span>支付宝支付</span>
            </div>
            <div @click="pay = 'alipay'" :class="pay == 'alipay' ? 'ok' : 'no'">
              <img v-if="pay == 'alipay'" src="/static/images/default/y.png">
            </div>
          </div>
        </div>
        <div class="bottom-button" @click="rechargeClick">充值</div>
      </div>
    </van-popup>

<!--    <div class="distribution-head">-->
<!--      <div class="head-left">-->
<!--        <div class="commission-title">可提现余额</div>-->
<!--        <div class="commission">-->
<!--          ￥{{ balance ? formatPrice(balance) : 0 }}-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="head-right">-->
<!--        &lt;!&ndash; 有公会功能并且为 true就是可提现 &ndash;&gt;-->
<!--        <van-button v-if="$hasFeature('guild') && withdrawalsSwitch == 'false'" round plain size="small" color="#fff" type="primary">提现功能冻结中</van-button>-->
<!--        <van-button v-else round plain size="small" color="#fff" type="primary" @click="show = true">提现</van-button>-->
<!--      </div>-->
<!--    </div>-->

<!--    <van-dialog v-model="show" title="提现申请" class="withdrawal"-->
<!--                show-cancel-button-->
<!--                confirm-button-text="提现"-->
<!--                :before-close="withdrawClick">-->
<!--      <van-cell-group inset>-->
<!--        <van-field v-model="withdrawalAmount" label="提现金额" type="number" />-->
<!--        <div style="font-size: 12px">-->
<!--          当前可提现余额<span style="color: red">{{ balance ? formatPrice(balance) : 0 }}</span>元，-->
<!--          <span style="color: var(&#45;&#45;primary-color)" @click="wholeClick">全部提现</span>-->
<!--        </div>-->
<!--        <span v-if="$store.state.shop.id === 154" style="color: red;font-size: 11px;">注：提现服务费：10%</span>-->
<!--        <van-field v-model="realName" label="微信实名" placeholder="账号绑定的微信号实名名字"/>-->
<!--        <span style="color: red;font-size: 11px;">注意：请用绑定微信的实名名字，不然会导致付款失败！</span>-->

<!--        <div v-if="accountSetting.uploadScreenshotEnable">-->
<!--          <div style="font-size: 14px;color: #646566;margin-top: 10px">-->
<!--            上传截图-->
<!--            <span style="font-size: 11px;color: red">说明：上传2张作业截图</span>-->
<!--          </div>-->
<!--          <uploadPhoto :imgArr="screenshot" imgAmount="3" @uploadimg="uploadimg" titleText="上传截图"></uploadPhoto>-->
<!--        </div>-->

<!--      </van-cell-group>-->
<!--    </van-dialog>-->

<!--    <div class="balance-list">-->
<!--      <div class="title">-->
<!--        余额明细-->
<!--      </div>-->
<!--      <van-list-->
<!--          v-model="loading"-->
<!--          :finished="finished"-->
<!--          finished-text="没有更多了"-->
<!--          @load="listBalanceDetail">-->
<!--        <template v-for="(item, index) in detailList">-->
<!--          <div class="balance-detail">-->
<!--            <div class="balance-between">-->
<!--              <div style="color: black;font-weight: 500;font-size: 14px;display: flex;align-items: center">-->
<!--                {{ item.actionName }}-->
<!--                <span v-if="item.action === 'withdraw'" style="margin-left: 5px;">-->
<!--                  <van-tag v-if="item.status === 0" type="warning">待付款</van-tag>-->
<!--                  <van-tag v-if="item.status === 1" type="primary">付款中</van-tag>-->
<!--                  <van-tag v-if="item.status === 2" type="success">已付款</van-tag>-->
<!--                  <van-tag v-if="item.status === 3" type="danger">付款失败</van-tag>-->
<!--                  <van-tag v-if="item.status === -1">已撤销</van-tag>-->
<!--                </span>-->
<!--              </div>-->
<!--              <div style="font-weight: bold;font-size: 14px;"-->
<!--                   :style="item.changeAmount > 0 ? 'color: orange' : 'color: black'">-->
<!--                {{ formatPrice(item.changeAmount) }}-->
<!--              </div>-->
<!--            </div>-->
<!--            <div v-if="item.detail && item.detail.platformFee" style="padding: 2px 5px;display: flex;justify-content: right">-->
<!--              手续费（{{item.detail.platformFeeRatio}}）：{{ formatPrice(item.detail.platformFee) }}-->
<!--            </div>-->
<!--            <div v-if="item.action == 'update'" style="padding: 2px 5px;">-->
<!--              备注：{{ item.detail.remark }}-->
<!--            </div>-->
<!--            <div class="balance-between">-->
<!--              <div>-->
<!--                {{ formatDate(item.createTime, 'MM-DD HH:mm') }}-->
<!--              </div>-->
<!--              <div>-->
<!--                <span style="margin-right: 5px;font-size: 14px">账户余额</span>{{ formatPrice(item.afterChangeAmount) }}-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </template>-->
<!--      </van-list>-->
<!--    </div>-->

  </div>
</template>

<script>
import Vue from 'vue';
import {
  Progress,
  Button,
  Cell,
  CellGroup,
  Field,
  List,
  Dialog,
  Toast,
  Tag,
  Divider,
  Icon,
  Popup,
  DatetimePicker, Uploader
} from "vant"
import Decimal from "decimal.js";
import moment from 'moment';
import {getBalance, withdraw, listBalanceDetail, recharge} from '@/api/balance'
import uploadPhoto from '@/views/uploadPhoto'
import {wx, wxConfig} from '@/libs/jssdk-util'

Vue.use(Progress)
    .use(Cell)
    .use(CellGroup)
    .use(Dialog)
    .use(Field)
    .use(Button)
    .use(List)
    .use(Tag)
    .use(Divider)
    .use(Icon)
    .use(Popup)
    .use(DatetimePicker)
    .use(Uploader)
export default {
  name: "distribution-index",
  components: {
    uploadPhoto
  },
  data() {
    return {
      pay: 'weixin',
      tab: null,
      timePop: false,
      txpop: false,
      czpop: false,
      startTime: null,
      endTime: null,
      frozeAmount: null,
      okWithdrawal: null,
      imgList: [],
      recharge: null,
      showCZ: null,
      showTX: null,
      datetimePicker: {
        field: null,
        value: null,
        maxDate: moment().add('3', 'month').toDate()
      },
      datetimePickerPopupShow: false,
      detailList: [],
      gradeName: null,
      pageNo: 1,
      pageSize: 10,
      loading: false,
      finished: false,
      consumeCount: null,
      show: false,
      withdrawal: false,
      money: null,
      url: null,
      accountBalance: null,//其他角色余额
      balance: null,
      tipsShow: false,
      articleId: null,
      withdrawalAmount: null,
      realName: null,
      screenshot: [],
      withdrawalsSwitch: true,
      accountSetting: {
        uploadScreenshotEnable: null,
        clerkWagesChangeBalanceEnable: false
      },
      clerkSetting:{
        wageSettleType: null
      },
      rechargePayMethodList: []
    }
  },
  watch: {
    withdrawalAmount: function () {
      let dotIndex = this.withdrawalAmount.toString().indexOf('.')
      if (dotIndex != -1 && this.withdrawalAmount.toString().substring(dotIndex + 1).length > 2) {
        this.withdrawalAmount = this.withdrawalAmount.substring(0, dotIndex + 3)
      }
    }
  },
  methods: {
    onLogClick(log){
      if(log.role ==='clerk' && log.orderId ){
        if(log.detail.orderSettlementType === '平台订单'){
          this.$router.push(`/clerk/order/detail/${log.orderId}`)
        }else if(log.detail.orderSettlementType === '派单'){
          this.$router.push(`/clerk/dispatchOrder/detail/${log.orderId}`)
        }
      }
    },
    tabClick(item){
      this.tab = item
      this.loadData()
    },
    timeClick(){
      this.timePop = true
    },
    showDatetimePickerPopup(field) {
      this.datetimePicker.field = field
      if (field == 'start') {
        this.datetimePicker.value = moment(this.startTime).toDate()
      } else if (field == 'end') {
        this.datetimePicker.value = moment(this.endTime).toDate()
      }
      this.datetimePickerPopupShow = true;
    },
    datetimePickerFormatter(field, value) {
      if (field === 'year') {
        return `${value}年`;
      } else if (field === 'month') {
        return `${value}月`
      } else if (field == 'day') {
        return `${value}日`
      }
      return value;
    },
    datetimePickerConfirm(value) {
      this.datetimePickerPopupShow = false;
      if (this.datetimePicker.field == 'start') {
        this.startTime = moment(value).format('YYYY-MM-DD');
      } else if (this.datetimePicker.field == 'end') {
        this.endTime = moment(value).format('YYYY-MM-DD');
      }
    },
    queryClick(){
      if(!this.startTime){
        return Toast("请选择开始时间");
      }
      if(!this.endTime){
        return Toast("请选择结束时间");
      }
      this.listBalanceDetail(true)
      this.timePop = false
    },
    cancellation(){
      this.startTime = null
      this.endTime = null
      this.listBalanceDetail(true)
      this.timePop = false
    },
    rechargeClick(){
      if(!this.recharge){
        return Toast("请输入充值金额");
      }
      const vm = this;
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      recharge(
          Decimal.mul(this.recharge, 100).toNumber(),
          this.pay
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          if (this.pay == 'weixin') {
            const payData = data.data;
            wx.chooseWXPay({
              timestamp: payData.timeStamp,
              nonceStr: payData.nonceStr,
              package: payData.packageValue,
              signType: payData.signType,
              paySign: payData.paySign,
              success() {
                Dialog.alert({
                  title: '支付成功',
                  confirmButtonColor: 'var(--primary-color)',
                  beforeClose: (action, done) => {
                    this.loadData()
                    done()
                  }
                })
              },
              fail (err) {
                Toast(err.errMsg ? err.errMsg : '支付失败')
              }
            })
          }else if(this.pay == 'alipay'){
            console.log(data)
            vm.$router.push({
              path: `/toAlipay/balanceRecharge/${data.data}`
            })
          }
        } else {
          Dialog.alert({
            title: '创建订单失败',
            message: data.msg
          })
        }
      })
    },
    uploadimg(imgarr){
      this.screenshot = imgarr
    },
    withdrawClick() {
      if (this.withdrawalAmount == "") {
        return Toast("请输入金额");
      } else if (this.withdrawalAmount <= 0) {
        return Toast("请输入正确金额");
      } else if (Number(this.withdrawalAmount) < this.accountSetting.minWithdrawAmount) {
        return Toast("提现金额小于最小提现金额");
      } else if (Number(this.withdrawalAmount) > this.accountSetting.maxWithdrawAmount) {
        return Toast("提现金额大于最大提现金额");
      } else if (Number(this.withdrawalAmount) > this.formatPrice(this.balance)) {
        return Toast("余额不足");
      }
      if (this.realName == '' || this.realName == null) {
        return Toast("请填写实名名字");
      }
      if (this.accountSetting.uploadScreenshotEnable === true && this.imgList.length < 2) {
        return Toast("请填写上传2张作业截图");
      }
      Toast.loading({
        mask: true,
        message: '请稍候...',
        duration: 0
      })
      let screenshotList = []
      this.imgList.forEach(v => {
        let screenshot = {
          base: v.content,
          // filename: v.file.name
        }
        screenshotList.push(screenshot)
      })
      withdraw(
          this.tab === 'account'?null:this.tab,
          Decimal.mul(this.withdrawalAmount, 100).toNumber(),
          this.realName,
          JSON.stringify(screenshotList)
      ).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '提示',
            message: '提交成功'
          }).then(() => {
            this.txpop = false
            this.withdrawalAmount = null
            this.imgList = []
            this.loadData()
          })
        } else {
          Dialog.alert({
            title: '提交失败',
            message: data.msg
          })
        }
      })
    },
    wholeClick() {
      if (this.formatPrice(this.balance) == 0) {
        return Toast("可提现佣金为0元");
      } else {
        this.withdrawalAmount = this.formatPrice(this.balance)
      }
    },
    getBalance() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      getBalance().then(res => {
        Toast.clear()
        const data = res.data
        if (data.code == 0) {
          if(this.tab == 'clerk'){
            this.balance = data.clerkBalance
          }else if(this.tab == 'leader'){
            this.balance = data.leaderBalance
          }else if(this.tab == 'kf'){
            this.balance = data.kfBalance
          }else if(this.tab == 'admin'){
            this.balance = data.adminBalance
          }else if(this.tab == 'account'){
            this.balance = data.balance
          }
          this.accountBalance = data.balance
          this.withdrawalsSwitch = data.withdrawalsSwitch
          this.accountSetting = data.accountSetting
          this.clerkSetting = data.clerkSetting
          this.realName = data.realName
          if(this.tab === 'clerk'){
            if(this.balance <= data.clerkBalanceSetting.frozeAmount){
              this.frozeAmount = Math.max(this.balance,0)
              this.okWithdrawal = 0
            }else {
              this.frozeAmount = data.clerkBalanceSetting.frozeAmount
              this.okWithdrawal = this.balance - this.frozeAmount
            }
          }else{
            this.okWithdrawal = this.balance
          }

          this.showCZ = data.clerkBalanceSetting.allowRecharge
          this.showTX = data.accountSetting.accountBalanceEnable
          this.rechargePayMethodList = data.rechargePayMethodList
        } else {
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
      })
    },
    listBalanceDetail(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1;
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.detailList = [];
      }
      this.loading = true;
      listBalanceDetail(
          this.tab,
          this.startTime,
          this.endTime,
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false;
        const data = res.data
        if (data.code == 0) {
          this.detailList = this.detailList.concat(data.list);
          if (data.hasNextPage) {
            this.finished = false;
          } else {
            this.finished = true;
          }
        } else {
          this.finished = true;
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++;
      })
    },
    loadData() {
      this.getBalance();
      this.listBalanceDetail(true)
    },
    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    }
  },
  mounted() {
    let roleList = ['clerk','leader','kf','admin','account']
    for (let i = 0; i < roleList.length; i++) {
      if(this.$hasRole(roleList[i])){
        this.tab = roleList[i]
        break;
      }
    }
    wxConfig(['chooseWXPay'])
  },
  activated() {
    this.getBalance()
  }
}
</script>

<style lang="less" scoped>
.page {
  height: 100vh;
  background: #fff;
  display: flex;
  flex-flow: column;
  .tab-box{
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    height: 46px;
    border-bottom: 1px #F0F0F0 solid;
    .tab-item{
      font-weight: 500;
      font-size: 15px;
      line-height: 15px;
      color: #808080;
      position: relative;
      .l{
        width: 23px;
        height: 3px;
        background: var(--primary-color);
        border-radius: 999px;
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translate(-50%,100%);
      }
    }
    .item-click{
      font-weight: bold;
      color: #333333;
    }
  }
  .wallet-box{
    padding: 13px;
    border-bottom: 7px #F5F5F5 solid;
    .wallet{
      width: calc(100% - 16px * 2);
      height: 138px;
      border-radius: 10px;
      background: var(--primary-color);
      position: relative;
      padding: 0 16px;
      .line1{
        display: flex;
        justify-content: space-between;
        .left-box{
          padding-top: 20px;
          .title{
            display: flex;
            align-items: center;
            font-weight: bold;
            font-size: 15px;
            line-height: 15px;
            color: #FFFFFF;
            .unit{
              font-weight: 500;
              font-size: 13px;
              line-height: 13px;
              color: #FFFFFF;
              margin-left: 7px;
            }
          }
          .amount{
            font-weight: bold;
            font-size: 24px;
            line-height: 24px;
            color: #FFFFFF;
            margin-top: 13px;
          }
        }
        .right-box{
          display: flex;
          flex-flow: column;
          justify-content: end;
          height: 92px;
          .button{
            width: 67px;
            height: 27px;
            border-radius: 999px;
            border: 1px solid rgba(245,245,245,0.5);
            font-weight: 500;
            font-size: 13px;
            line-height: 27px;
            color: #FFFFFF;
            text-align: center;
          }
          .button-margin{
            margin-bottom: 18px;
          }
        }
      }
      .line2{
        display: flex;
        align-items: center;
        font-weight: 500;
        font-size: 13px;
        line-height: 13px;
        color: #FFFFFF;
        div{
          margin-right: 26px;
        }
      }
      .wallet-bg{
        width: 100%;
        display: block;
        position: absolute;
        bottom: 0;
        left: 0;
      }
    }
  }
  .list-title{
    height: 56px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 13px;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    border-bottom: 1px #F0F0F0 solid;
    .time{
      height: 27px;
      background: #F0F0F0;
      border-radius: 999px;
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 12px;
      color: #808080;
      padding: 0 11px 0 18px;
      img{
        width: 8px;
        display: block;
        margin-left: 6px;
      }
    }
  }
  .list-box{
    flex: 1;
    padding: 0 13px;
    overflow-y: auto;
    .list-item{
      padding: 15px 0;
      border-bottom: 1px #F0F0F0 solid;
      display: flex;
      justify-content: space-between;
      .text1{
        font-weight: 500;
        font-size: 14px;
        line-height: 14px;
        color: #333333;
        margin-right: 5px;
      }
      .text2{
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #B3B3B3;
        margin-top: 13px;
      }
      .text3{
        font-weight: bold;
        font-size: 14px;
        line-height: 14px;
        color: #333333;
        text-align: right;
      }
      .text4{
        font-weight: 500;
        font-size: 12px;
        line-height: 12px;
        color: #B3B3B3;
        margin-top: 13px;
        text-align: right;
      }
    }
  }
}

.popstyle{
  width: calc(100% - 15px * 2);
  padding: 15px;
  .button-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    .button1{
      width: 49%;
      height: 35px;
      background: #b3b3b3;
      color: #fff;
      line-height: 35px;
      text-align: center;
    }
    .button2{
      width: 49%;
      height: 35px;
      background: var(--primary-color);
      color: #fff;
      line-height: 35px;
      text-align: center;
    }
  }
}

.txpop{
  border-radius: 13px;
  width: 80vw;
  .title{
    height: 49px;
    line-height: 49px;
    text-align: center;
    border-bottom: 1px #F2F2F2 solid;
    position: relative;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
    img{
      width: 22px;
      height: 22px;
      display: block;
      position: absolute;
      top: 9px;
      right: 9px;
    }
  }
  .popbody{
    padding: 0 27px 28px 27px;
    .line{
      padding-top: 20px;
      display: flex;
      align-items: center;
      .line-title{
        width: 70px;
        font-weight: 500;
        font-size: 15px;
        color: #333333;
      }
      .field{
        flex: 1;
        padding: 0;
        line-height: 36px;
        /deep/.van-field__control{
          background: #F5F5F5;
          border-radius: 6px;
        }
      }
    }
    .tip{
      font-weight: 500;
      font-size: 13px;
      line-height: 13px;
      color: #999999;
      padding-left: 70px;
      padding-top: 10px;
    }
    .tip2{
      font-weight: 500;
      font-size: 10px;
      line-height: 10px;
      color: #FF5860;
      padding-top: 20px;
    }
    .pay-box{
      padding-top: 23px;
      padding-bottom: 22px;
      .pay-item{
        padding-top: 24px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .left-box{
          display: flex;
          align-items: center;
          font-weight: 500;
          font-size: 13px;
          color: #1A1A1A;
          img{
            width: 20px;
            height: 20px;
            display: block;
            margin-right: 8px;
          }
        }
        .ok{
          width: 20px;
          height: 20px;
          background: var(--primary-color);
          border-radius: 50%;
          img{
            width: 100%;
            height: 100%;
            display: block;
          }
        }
        .no{
          width: 20px;
          height: 20px;
          border-radius: 50%;
          border: 1px solid #808080;
          box-sizing: border-box;
        }
      }
    }
    .bottom-button{
      margin-top: 21px;
      height: 42px;
      background: var(--primary-color);
      border-radius: 999px;
      line-height: 42px;
      text-align: center;
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
    }
  }
}



.balance-list {
  font-size: 12px;
  padding: 10px 0;

  .title {
    padding: 5px;
    font-size: 15px;
    font-weight: bold;
  }

  .balance-detail{
    border-bottom: 1px solid #efefef;
    padding: 5px 0;

    .balance-between {
      display: flex;
      justify-content: space-between;
      padding: 2px 5px;
    }
  }


}


.distribution-head {
  width: 100%;
  height: 110px;
  background: var(--primary-color);
  border-radius: 5px;
  display: table;
  table-layout: fixed;
}

.head-left {
  width: 100%;
  height: 110px;
  display: table-cell;
}

.head-right {
  width: 100%;
  height: 110px;
  display: table-cell;
  padding-right: 30px;
  vertical-align: middle;
}

.commission-title {
  padding-top: 25px;
  padding-left: 30px;
  color: #fff;
  font-size: 14px;
}

.commission {
  padding-top: 10px;
  padding-left: 30px;
  color: #fff;
  font-size: 26px;
}

.withdrawal {
  padding: 5px 10px;

  .title {
    font-size: 16px;
    color: #323233;
  }

}

/deep/ .van-button {
  float: right;
}

/deep/ .van-button--plain {
  background: rgba(255, 255, 255, 0.3);
}

/deep/ .van-button--round {
  border-radius: 100px;
}

/deep/ .van-button--small {
  padding: 0 20px;
}

.record {
  width: 100%;
  height: 100px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.record .record-box {
  width: 47%;
  height: 80px;
  border-radius: 5px;
  box-shadow: 0px 0px 5px 1px #d0d0d0;
}

.record-num {
  width: 100%;
  text-align: center;
  margin-top: 15px;
  font-size: 16px;
  font-weight: bold;
}

.record-title {
  width: 100%;
  text-align: center;
  margin-top: 5px;
  font-size: 14px;
  color: #999999;
}

.van-hairline--top-bottom:after, .van-hairline-unset--top-bottom:after {
  border: none;
}

.van-cell {
  padding: 10px 0px;
}

.van-cell:after {
  left: 0;
  right: 0;
}

.qrbox {
  display: table;
  margin: 10px auto;
}

/deep/ .van-field__control {
  background-color: rgba(208, 200, 200, 0.3);
  padding: 3px 10px;
  border-radius: 5px;
}

/deep/ .van-field__label {
  width: 4.2em;
}

.invitation-title {
  padding: 10px 0;
  font-size: 20px;
  font-weight: bold;
}

.border-right {
  border: 1px solid #f8f8f8;
  margin-top: 15px
}


.van-cell::after {
  border: none;
}

</style>
